import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { PhonePerformanceMetricBaseColumn } from './performance-metric-base-column';
import callTrackingStatusTemplate from './call-forwarding.pug';

/**
 * Call forwarding
 * @extends CampaignuiBaseColumn
 */

export class ColumnCallForwarding extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_CallMeteringEligibility');

    super({
      name: 'CallForwarding',
      property: 'CallTrackingStatus',
      title,
      sortable: 'CallTrackingStatus',
      type: 'string',
      helpId: 'Page_AdExtensions_CallForward',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.schemaI18n = new SchemaI18n({ i18n });
  }

  template({ value }) {
    return callTrackingStatusTemplate({ value, schemaI18n: this.schemaI18n });
  }
}


/**
 * Manual calls
 * @extends PhonePerformanceMetricBaseColumn
 */
export class ColumnManualCalls extends PhonePerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_PhoneCalls' }) {
    super({
      name: 'ManualCalls',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}


/**
 * Phone impressions
 * @extends PhonePerformanceMetricBaseColumn
 */
export class ColumnPhoneImpressions extends PhonePerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_PhoneImpr' }) {
    super({
      name: 'PhoneImpressions',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * PTR
 * @extends PhonePerformanceMetricBaseColumn
 */
export class ColumnPTR extends PhonePerformanceMetricBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'PTR',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}


/**
 * All call details columns
 * @type Class[]
 */
export const callDetailsColumns = [
  ColumnCallForwarding,
  ColumnManualCalls,
  ColumnPhoneImpressions,
  ColumnPTR,
];
